import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, httpAction } from '@/api/manage';
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
export default {
  name: 'comment',
  mixins: [ModalFormMixin],
  data: function data() {
    return {
      url: {
        comment: '/om/work/opinion/getByOrigin',
        addComment: '/om/work/opinion'
      },
      commentList: [],
      replyId: '',
      visibleComment: false,
      confirmLoadingComment: false,
      opinion: '',
      memo: ''
    };
  },
  props: {
    originId: {
      type: Number,
      default: 0
    },
    originKey: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    this.loadComment();
  },
  computed: {},
  methods: {
    loadComment: function loadComment() {
      var _this = this;

      getAction(this.url.comment + '?originId=' + this.originId + '&originKey=' + this.originKey).then(function (res) {
        if (res.success) {
          _this.commentList = res.result;
        }
      });
    },
    addComment: function addComment() {
      var param = {};
      param.originKey = this.originKey;
      param.originId = this.originId;
      param.parentId = 0;
      param.opinion = this.memo;
      var that = this;
      httpAction(this.url.addComment, param, 'post').then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadComment();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      }).finally(function () {
        that.memo = '';
      });
    },
    handleReply: function handleReply(id) {
      this.opinion = '';
      this.replyId = id;
      this.visibleComment = true;
    },
    handleComment: function handleComment(e) {
      this.confirmLoadingComment = true;
      var param = {};
      param.originKey = this.originKey;
      param.originId = this.originId;
      param.parentId = this.replyId;
      param.opinion = this.opinion;
      var that = this;
      httpAction(this.url.addComment, param, 'post').then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadComment();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      }).finally(function () {
        that.visibleComment = false;
        that.confirmLoadingComment = false;
      });
    },
    handleCancelComment: function handleCancelComment(e) {
      this.opinion = '';
      this.visibleComment = false;
    }
  }
};